<template>
  <div class="row">
    <div class="col-lg-6 col-lg-12 col-md-12 col-sm-12">
      <audience-profile-chart :loading="loading" :data="data.audienceProfile" />
    </div>

    <div class="col-lg-6 col-md-12 col-sm-12">
      <cross-platform-engagement-chart :loading="loading" :data="data.crossPlatformEngagement" />
    </div>
  </div>
</template>

<script>
import AudienceProfileChart from '@/components/profiles/charts/AudienceProfileChart';
import CrossPlatformEngagementChart from '@/components/profiles/charts/CrossPlatformEngagement';

export default {
  name: 'ProfilesCharts',
  components: {
    AudienceProfileChart,
    CrossPlatformEngagementChart,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProfilesCharts.vue?24c01ce8